import React from 'react';
import { Col, Row, Alert } from 'react-bootstrap';

const HTTPError = (props) => {
  return (
    <Row className="justify-content-md-center">
      <Col sm={12}>
        <Alert variant="danger">
          <Alert.Heading>Tekkis viga!</Alert.Heading>
          <p>
            Broneerimine ei ole hetkel võimalik.
          </p>
        </Alert>
      </Col>
    </Row>
  );
}

export default HTTPError;